import { AppBackground, Button, Text, ResponsiveLogo } from '@ui/components'
import React, { useEffect } from 'react'
import {
  ButtonsContainer,
  Container,
  ContainerVaccines,
  HeaderContainer,
  NameContainer,
  NameText,
  PetImage,
  PictureContainer,
  WarningContainer,
} from './styles'

import { loadActualVaccineUrl, useAppDispatch, useAppSelector } from '@front/store'
import { useNavigate } from 'react-router-dom'
import { usePetVaccines } from '@front/logic'
import { Vaccine } from '@front/apis'
import { ItemWithIcon, VaccineTable } from '@/components/itemwithicon'
import { ScrollView, View } from 'react-native'
import { HeaderWithBackAena } from '@/components/headerwithback'
import { t } from 'i18next'
import { ReactComponent as AlertTriangleIcon } from '@/assets/icons/aena/aena_alert_triangle.svg'

const parseAgeToVaccinate = (ageToVaccinate: string|null) => {
  if (!ageToVaccinate)
    return ""
  if (ageToVaccinate === 'ADULTO')
    return t(`common.ADULTO`)
  if (ageToVaccinate.includes('semanas'))
    return t(`vaccines.ageToVaccinate.from`) + ageToVaccinate.replace('semanas', '') + t(`vaccines.ageToVaccinate.WEEKS`)
  if (ageToVaccinate.includes('meses'))
    return t(`vaccines.ageToVaccinate.from`) + ageToVaccinate.replace('meses', '') + t(`vaccines.ageToVaccinate.MONTHS`)
  if (ageToVaccinate.includes('días'))
    return t(`vaccines.ageToVaccinate.from`) + ageToVaccinate.replace('días', '') + t(`vaccines.ageToVaccinate.DAYS`)
  return ageToVaccinate
}

export const Vaccines: React.FC = () => {
  const petToPublish = useAppSelector((state) => state.selectedPet)
  const appliedVaccines = useAppSelector((state) => state.petDocumentation.appliedVaccines)
  const mandatoryVaccines = useAppSelector((state) => state.petDocumentation.mandatoryVaccines)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { getVaccines } = usePetVaccines()

  console.log({ mandatoryVaccines })
  const pendingMandatory = mandatoryVaccines.filter(vaccine => !vaccine.isUpToDate).length > 0

  // Check for pending or expired mandatory vaccines
  const pendingMandatoryVaccines = appliedVaccines?.filter(vaccine =>
    vaccine.type === 'MANDATORY' && !vaccine.isUpToDate
  ) || []


  // console.debug('Debug vaccine data:', {
  //   appliedVaccines,
  //   pendingMandatoryVaccines,
  //   hasPendingMandatoryVaccines,
  //   mandatoryVaccines
  // })

  const handleVaccinePress = (item: Vaccine) => {
    return navigate('history', {
      state: {
        tname: item.tname,
        history: item.history,
        periodicity: item.periodicity,
        ageToVaccinate: item.ageToVaccinate,
        afterHowManyMonths: item.afterHowManyMonths,
        vaccine: item
      },
    })
  }

  const handleAddVaccinePress = () => {
    console.debug('ADD VACCINE')
    dispatch(loadActualVaccineUrl(''))
    navigate('add')
  }

  useEffect(() => {
    getVaccines()
  }, [])

  console.log({appliedVaccines})
  return (
    <AppBackground isSafe>
      <View style={{ maxWidth: 800, width: '100%', alignSelf: 'center' }}>
        <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: 16, gap: 16 }}>
          <ResponsiveLogo
            breakpoint={820}
            hysteresis={20}
            large={{ width: 680, height: 96 }}
            small={{ width: 360, height: 48 }}
          />
        </View>
        <HeaderWithBackAena title={t('common.vaccines')} />
        <View style={{ padding: 16 }}>
          <ScrollView>
          <Container>
          <HeaderContainer>
            <PictureContainer width={180} aspectRatio={1}>
              <PetImage src={petToPublish?.avatar || ''} />
            </PictureContainer>
            <NameContainer>
              <NameText type="H3" fontFamily="bold" fontWeight="bold">
                {`${t('common.helloim')} ${petToPublish?.name}`}
              </NameText>
            </NameContainer>
          </HeaderContainer>
          <ButtonsContainer style={{ alignItems: 'flex-end' }}>
            <View style={{ alignItems: 'flex-end', width: '100%' }}>
              <Button
                title={t('common.add')}
                buttonWrapperStyle={{ backgroundColor: '#96ce00' }}
                size="small"
                textType="cta_medium"
                borderRadius={5}
                textColor="background0"
                allowIconAndText
                color="primary"
                onPress={() => handleAddVaccinePress()}
              /></View>
          </ButtonsContainer>
          {pendingMandatory && (
            <WarningContainer>
              <View style={{ color: '#B24810' } as any}>
                <AlertTriangleIcon width={32} height={32} />
              </View>
              <View style={{ flex: 1 }}>
                <Text type="H5" fontFamily="bold" fontWeight="bold" style={{ color: '#B24810' }}>
                  {t('vaccines.aviso')}
                </Text>
                <Text type="caption" style={{ marginTop: 4, color: '#B24810' }}>
                  {t('vaccines.important_to_keep_mandatory_vaccines_up_to_date')}
                </Text>
              </View>
            </WarningContainer>
          )}
          {appliedVaccines?.length > 0 && (
            <Text type="H4" fontFamily="bold" fontWeight="bold" textAlign="left">
              {t('common.thesearemyvaccines')}
            </Text>
          )}
          <ContainerVaccines>
            {appliedVaccines?.length === 0 ? (
              <Text type="H5" textAlign="center">
                {t('common.youhavenotappliedanyvaccines')}
              </Text>
            ) : (
              <>
                <VaccineTable showStatus>
                  {appliedVaccines?.map((item, index) => (
                    <ItemWithIcon
                      title={t(`vaccines.${item.tname}`)}
                      description={parseAgeToVaccinate(item.ageToVaccinate)}
                      key={`${item.guid}-${index}`}
                      onPress={() => handleVaccinePress(item)}
                      isMandatory={item.type === 'MANDATORY'}
                      isUpToDate={item.isUpToDate}
                      periodicity={t(`common.${item.periodicity}`)}
                      showHistoryButton={true}
                      onHistoryPress={() => handleVaccinePress(item)}
                      vaccine={item}
                      showStatus={true}
                    />
                  ))}
                </VaccineTable>
              </>
            )}
          </ContainerVaccines>
        </Container>            
          </ScrollView>
        </View>

      </View>
    </AppBackground>
  )
}

export default Vaccines
